import styled from 'styled-components/macro';

const ColumnInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: auto;
`;

export default ColumnInfo;
